import {ConnectedRouter} from 'connected-react-router';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';

// absolute imports are possible thanks to the configuration in jsconfig.json
// import AppCatalogueCreation from 'components/AppCatalogue/AppCatalogueCreation';
import AppCatalogueProject from 'components/AppCatalogue/AppCatalogueProject';
import Banner from 'components/Banner/Banner';
import CernToolbar from 'components/CernToolbar';
import Footer from 'components/Common/Footer/Footer';
import SuccessMessages from 'components/Common/SuccessMessages/SuccessMessages';
import DrupalSite from 'components/Drupal/DrupalSite';
import ErrorContainer from 'components/ErrorContainer';
import GitlabPagesSite from 'components/GitlabPagesSite/GitlabPagesSite';
import GitlabPagesSiteCreation from 'components/GitlabPagesSite/GitlabPagesSiteCreation';
import LandingPage from 'components/LandingPage/LandingPage';
import LoginCallback from 'components/LoginCallback';
import LogoutCallback from 'components/LogoutCallback';
import NexusCreation from 'components/Nexus/NexusCreation';
import NexusProject from 'components/Nexus/NexusProject';
import PaaSCreation from 'components/PaaS/PaaSCreation';
import PaaSProject from 'components/PaaS/PaaSProject';
import PortalToolbar from 'components/PortalToolbar';
import ProtectedRoute from 'components/ProtectedRoute';
import SearchPage from 'components/Search/SearchPage/SearchPage';
import ShortUrlsPage from 'components/ShortUrls/ShortUrlsPage';
import SiteList from 'components/SiteList/SiteList';
import WebEOSCreation from 'components/WebEOS/WebEOSCreation';
import WebEOSSite from 'components/WebEOS/WebEOSSite';
import WordPressCreation from 'components/WordPress/WordPressCreation';
import WordPressSite from 'components/WordPress/WordPressSite';

import styles from './App.module.scss';

export default function App({history}) {
  return (
    <ConnectedRouter history={history}>
      <div className={styles.App}>
        <Switch>
          <Route path="/callback">
            <LoginCallback />
          </Route>
          <Route path="/logout">
            <LogoutCallback />
          </Route>
          <Route path="/">
            <SuccessMessages />
            <ErrorContainer />
            <CernToolbar />
            <Banner />
            <PortalToolbar />
            <Switch>
              {/* Use ProtectedRoute for all components which require the user to be logged in */}
              <ProtectedRoute
                component={WebEOSCreation}
                exact
                path="/webeos"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              />
              <ProtectedRoute component={SiteList} exact path="/my-sites" />
              <ProtectedRoute component={WebEOSSite} exact path="/webeos/:projectName" />
              <ProtectedRoute component={DrupalSite} exact path="/drupal/:projectName" />
              <ProtectedRoute component={PaaSProject} exact path="/paas/:projectName" />
              <ProtectedRoute
                component={PaaSCreation}
                exact
                path="/paas"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              />
              {/* <ProtectedRoute
                component={AppCatalogueCreation}
                exact
                path="/app-catalogue"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              /> */}
              <ProtectedRoute
                component={AppCatalogueProject}
                exact
                path="/app-catalogue/:projectName"
              />
              <ProtectedRoute
                component={NexusCreation}
                exact
                path="/nexus"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              />
              <ProtectedRoute component={NexusProject} exact path="/nexus/:projectName" />
              <ProtectedRoute
                component={GitlabPagesSiteCreation}
                exact
                path="/gps"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              />
              <ProtectedRoute component={GitlabPagesSite} exact path="/gps/:projectName" />
              <ProtectedRoute
                component={WordPressCreation}
                exact
                path="/wordpress"
                allowSecondaryAccount={false}
                allowServiceAccount={false}
              />
              <ProtectedRoute component={WordPressSite} exact path="/wordpress/:projectName" />
              <ProtectedRoute component={SearchPage} exact path="/search/:query?" />
              <ProtectedRoute component={ShortUrlsPage} exact path="/short-urls" />
              <Route>
                <LandingPage />
              </Route>
            </Switch>
            <Footer />
          </Route>
        </Switch>
      </div>
    </ConnectedRouter>
  );
}

App.propTypes = {
  history: PropTypes.object.isRequired,
};
